export default {"src":"/_next/static/media/back-to-top-icon.44b3e955.svg","height":21,"width":35,"blurWidth":0,"blurHeight":0};